/**
 * DailySignalNudge — shows a small "today's nudge" prompt rotating across
 * the week. Stored in localStorage per-day so it doesn't re-render after
 * the member dismisses it.
 */
import { useState } from "react";
import { Sparkles, X } from "lucide-react";

const NUDGES = [
  "Send one Signal you've been thinking about. The other person can't read your hesitation.",
  "Refresh one prompt — even a single new sentence changes the algorithm's read of you.",
  "Open RAELA. Tell her one thing you didn't say out loud yesterday.",
  "Look at your matches. The conversation you're avoiding is probably the one worth having.",
  "Adjust one filter you set in a different mood. Past-you doesn't always know best.",
  "Save a venue from the safe-meet map. Future you will thank you.",
  "Re-record your voice intro. People match on tone, not just words.",
];

const todayKey = () => `wavlynq:nudge:${new Date().toISOString().slice(0, 10)}`;

const DailySignalNudge = () => {
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(todayKey()) === "1";
  });

  if (dismissed) return null;

  const idx = new Date().getDay() % NUDGES.length;
  const message = NUDGES[idx];

  const dismiss = () => {
    try {
      window.localStorage.setItem(todayKey(), "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div className="rounded-2xl border border-primary/20 bg-primary/5 p-4 flex items-start gap-3">
      <Sparkles className="h-5 w-5 text-primary mt-0.5 shrink-0" aria-hidden />
      <div className="flex-1 text-sm">
        <p className="text-[11px] uppercase tracking-wider text-primary font-medium">Today's nudge</p>
        <p className="mt-1">{message}</p>
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-muted-foreground hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default DailySignalNudge;
